import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
  box: {
    marginTop: 15,
  },
  buttonGroup: {
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: 5,
    height: 44,
  },
  boxTitle: {
    fontSize: theme.fonts.sizes.font20PX,
    color: theme.colors.light.lightCyan,
  },
  boxQuestion: {
    fontSize: theme.fonts.sizes.font16PX,
    color: theme.colors.light.lightCyan,
    marginBottom: 5,
  },
  yesnoBtn: {
    background: theme.colors.dark.steelBlue,
    color: 'white',
    paddingTop: 10,
    paddingBottom: 10,
    paddingLeft: '20%',
    paddingRight: '20%',
    borderRadius: '8px',
    textTransform: 'none',

    '&:hover': {
      backgroundColor: theme.colors.dark.midnightBlue,
      color: '#FF9B07',
      border: '2px solid #FF9B07',
    },
  },
}));
